import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from 'antd'

export const Container = styled.div<{
  $loading: boolean
}>`
  display: flex;
  flex-direction: column;
  margin: 2rem 8%;
  text-align: center;
  height: 100%;

  ${(props) =>
    props.$loading &&
    css`
      display: grid;
      grid-template-columns: none;
      grid-column-gap: 1rem;
      width: 100%;
      margin: 2rem 0 0;
      justify-content: space-between;
      place-content: center;
      flex-grow: 1;
    `}
`

export const Statistics = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: left;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const StatisticsTvl = styled.div`
  width: 49%;
  padding: 1.8rem 2.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  backdrop-filter: blur(50px);
  background-size: cover;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Con = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const StatisticsTitle = styled.div`
  font-size: 28px;
  // font-family: Inter;

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
  }
`

export const StatisticsAvg = styled.div`
  width: 49%;
  padding: 1.8rem 2.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  backdrop-filter: blur(50px);
  background-size: cover;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 8px;
  }
`

export const Img = styled.img`
  width: 2rem;
  height: 2rem;
`

export const ImgCon = styled.div`
  width: 2rem;
  height: 2rem;
  position: relative;
  display: flex;
`

export const TotalStakeListCon = styled.div<{
  isdark: boolean
}>`
  width: 28rem;
  padding: 8px;
  border-radius: 1.2rem;
  position: absolute;
  bottom: -8px;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, 100%);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);

  &:before {
    position: absolute;
    top: 0;
    left: 50%;
    content: ' ';
    border: 6px solid transparent;
    border-bottom: 6px solid ${(props) => (props.isdark ? '#133e5b' : '#fff')};
    transform: translate(-50%, -100%);
  }
`

export const TotalStakeItemCon = styled.div`
  width: 26.4rem;
  height: 5.2rem;
  border-radius: 8px;
  padding: 0 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
`

export const UsdPriceText = styled.div`
  font-size: 12px;
`

export const Data = styled.div`
  font-size: 24px;
  // font-family: Inter;
  display: flex;
`

export const Data1 = styled.p`
  color: #666;
  font-size: 16px;
  margin: 0;
`

export const LineStyle = styled.div<{
  isdark: boolean
}>`
  height: 100%;
  border-left: ${(props) =>
    props.isdark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #EBEFF2'};
  margin: 0;

  @media (max-width: 768px) {
    width: 100%;
    border-bottom: ${(props) =>
      props.isdark
        ? '1px solid rgba(255, 255, 255, 0.1)'
        : '1px solid #EBEFF2'};
  }
`

export const PoolItemCon = styled.div`
  flex: 1;
`

export const TokenImgDirectionCon = styled.div<{
  isdark: boolean
}>`
  width: fit-content;
  margin: 0 auto;
  height: 5.2rem;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  border-radius: 1.2rem;
  box-shadow: 0 4px 4px 0
    ${(props) => (props.isdark ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.05)')};
  background-color: ${(props) => (props.isdark ? '#0a2a41' : '#fff')};
`

export const TokenImg = styled.img`
  width: 3.6rem;
  height: 3.6rem;
`

export const DirectionImg = styled.img`
  width: 2rem;
  height: 2rem;
  margin: 0 1rem;
`

export const TotalStakeLoading = styled.img`
  width: 2rem;
  height: 2rem;
`

export const AprLoading = styled.img`
  width: 1.4rem;
  height: 1.4rem;
`

export const PoolItem = styled.div`
  margin-top: -2.6rem;
  padding: 3.2rem 2rem 2.4rem 2.4rem;
  border-radius: 16px;
  position: relative;
  z-index: 1;
`

export const LineLeft = styled.div`
  text-align: left;
  flex: 1;
`

export const LineRight = styled.div`
  text-align: right;
  flex: 1;
`

export const ButtonCon = styled(Button)`
  border: none;
  height: fit-content;
`

export const TopUpBtn = styled(ButtonCon)`
  padding: 0.6rem 1.4rem;
  border-radius: 0.6rem;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`

export const LineTitle = styled.p`
  // font-family: Inter;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 0;
`

export const LineValue = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.8rem;
  letter-spacing: normal;
`

export const LinePerValue = styled.span`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
`

export const LineBtn = styled(ButtonCon)`
  width: 100%;
  padding: 1.6rem 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  border-radius: 8px;
`

export const WithdrawBtn = styled(LineBtn)`
  flex: 1;
  margin-right: 8px;
`

export const ClaimBtn = styled(WithdrawBtn)`
  margin-right: 0;
`

export const PersonalInfoItem = styled.div`
  width: calc(100% - 1.6rem);
  margin: -2.4rem auto 0;
  padding: 4rem 1.6rem 1.6rem;
  border-radius: 1.6rem;
`

export const PersonalInfoTitle = styled.div`
  // font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
`

export const PersonalInfoValue = styled(PersonalInfoTitle)`
  text-align: right;
`
